import { DashboardService } from "../dashboardService";
import { LocalStorageService } from "src/services/localStorageService";
import { CreationDateSortOptions, LocalStorageKeys, ClaimColumnHeader } from "src/enums";
import { ClaimsFilters } from "src/types";

class ClaimDashService extends DashboardService<ClaimColumnHeader, ClaimsFilters, CreationDateSortOptions, undefined> {
  constructor(localStorageService: LocalStorageService) {
    super(localStorageService, LocalStorageKeys.CLAIM_DASH_SETTINGS);
  }
}

export { ClaimDashService };
